// extracted by mini-css-extract-plugin
export default {"button":"SpecsButton_button__fjr6o"};